import { useState } from 'react';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import Image from 'next/image';
import styles from '@/styles/LogoutButton.module.css';
import { useLoader } from '@/contexts/LoaderContext';

export default function LogoutButton() {
  const { showLoader, hideLoader, isLoading } = useLoader();
  const router = useRouter();

  const handleLogout = async () => {

    showLoader();

    try {
      // Remove the user cookie
      Cookies.remove('user');

      // Redirect to login page
      await router.push('/login');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      hideLoader();
    }
  };

  return (
    <button
      className={styles.logoutButton}
      onClick={handleLogout}
      disabled={isLoading}
      title="Logout"
    >
      <Image
        src="/assets/images/logout.svg"
        alt="Logout"
        width={20}
        height={20}
        className={styles.logoutIcon}
      />
    </button>
  );
}